// This is a new implementation of `payment` reducer and should be used for newer developments.
// It handles multiple simultaneous payment context states.

import { CHECKOUT_CONTEXT_GIFT_CARD, CHECKOUT_CONTEXT_NEW_LOOP_CARD } from '../../actions/creators/checkout';
import * as actions from '../../actions/types';
import { combineReducers } from 'redux';

const isProcessing = (state = [], action) => {
    switch (action.type) {
        case actions.CHECKOUT_PAYMENT_IS_PROCESSING:
            return !action.context ? state : (action.isLoading ? [...state, action.context] : state.filter(id => id !== action.context));
        case actions.CHECKOUT_PAYMENT_PROCESSING_ASYNC:
            return !action.context ? state : (action.processing ? addToState(action.context, state) : removeFromState(action.context, state));
        case actions.CHECKOUT_PAYMENT_ERROR:
        case actions.CHECKOUT_PAYMENT_SUCCESS:
        case actions.PACKAGE_CHECKOUT_INIT:
            return removeFromState(action.context, state);
        default:
            return state;
    }
};

function addToState(context, state) {
    return [...state, context];
}

function removeFromState(context, state) {
    return state.filter(id => id !== context);
}

const errorData = (state = {}, action) => {
    switch (action.type) {
        case actions.CHECKOUT_PAYMENT_ERROR:
            return { ...state, [action.context]: action.error };
        case actions.CHECKOUT_PAYMENT_IS_PROCESSING:
        case actions.CHECKOUT_PAYMENT_SUCCESS:
        case actions.CHECKOUT_PAYMENT_PROCESSING_ASYNC:
        case actions.PACKAGE_CHECKOUT_INIT:
            const { [action.context]: _, ...rest } = state;
            return rest;
            return rest;
        default:
            return state;
    }
};

const successData = (state = {}, action) => {
    switch (action.type) {
        case actions.CHECKOUT_PAYMENT_SUCCESS:
            return { ...state, [action.context]: action.data };
        case actions.CHECKOUT_PAYMENT_IS_PROCESSING:
        case actions.CHECKOUT_PAYMENT_ERROR:
        case actions.CHECKOUT_PAYMENT_PROCESSING_ASYNC:
        case actions.PACKAGE_CHECKOUT_INIT:
            return deleteKeyFromState(action.context, state);
        case actions.WALLET_PURCHASE_RESULT_CLOSE:
            return deleteKeyFromState(CHECKOUT_CONTEXT_GIFT_CARD, state);
        case actions.NEW_LOOP_CARD_LOADED:
            return deleteKeyFromState(CHECKOUT_CONTEXT_NEW_LOOP_CARD, state);
        case actions.NEW_LOOP_CARD_CONFIRM_SUBMIT_SUCCESS:
            return Object.assign({}, state, { [CHECKOUT_CONTEXT_NEW_LOOP_CARD]: action.data });
        default:
            return state;
    }
};

function deleteKeyFromState(key, state) {
    const { [key]: _, ...rest } = state;
    return rest;
}

export default combineReducers({
    isProcessing,
    errorData,
    successData,
});